import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '@common/global';

@Pipe({
  name: 'video'
})
export class VideoPipe implements PipeTransform {
  video_url = "";
  constructor(private _global: GlobalService) { }
  transform(value: any, args?: any): any {
    let v_urls = this._global.baseVideo;
    let obj = value;
    if (obj != undefined) {
      var fileFormat = '.mp4';
      var mediaId = this._global.getVal(obj, 'id', '');
      var metadata = this._global.getVal(obj, 'metadata', '');
      if (metadata != undefined) {
        var pathToMedia = this._global.getVal(metadata, 'pathToMedia', '');
        if (pathToMedia != undefined) {
          var mediaObj = pathToMedia[mediaId];
          if (mediaObj != undefined) {
            fileFormat = "."+ this._global.getVal(mediaObj, 'fileFormat', 'mp4');
          }
        }
      }
      if (args != undefined) {
        if (args[0] == "activity") {
          this.video_url = "play/" + this._global.getVal(obj, 'mediaType', '') + "/" + this._global.getVal(obj, 'mediaId', '') + "/xl/" + this._global.getVal(obj, 'mediaName', 'noname') + "_" + this._global.getMilliseconds() + fileFormat;
        } else if (args[0] == "pathToMedia") {
          this.video_url = "/play/" + this._global.getVal(obj, 'mediaType', '') + "/" + this._global.getVal(obj, 'uid', this._global.getVal(obj, 'id', '')) + "/xl/" + + this._global.getVal(obj, 'name', 'noname') + "_" + this._global.getMilliseconds() + fileFormat;
        } else if (args[0] == "chat") {
          Object.entries(obj).forEach(([key, value]) => {
            if (value) {
              this.video_url = "/play/attachment/" + this._global.getVal(value, 'uid', '') + "/xl/" + this._global.getVal(value, 'name', 'noname') + "_" + this._global.getMilliseconds() + fileFormat;
            }
          });
        }
      } else {
        this.video_url = "play/" + this._global.getVal(obj, 'mediaType', '') + "/" + this._global.getVal(obj, 'id', '') + "/xl/" + this._global.getVal(obj, 'name', 'noname') + "_" + this._global.getMilliseconds() +  fileFormat;
      }
      //alert(v_urls[Math.floor(Math.random()* v_urls.length)]);  
    }
    return this.video_url;
  }
}
